import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { connect } from "react-redux";

import {
  LoadingIcon,
  CMSDefault,
  CMSListing,
  Partners,
  Funding,
  ResourceGlossary,
  Home,
} from "../../components";

function getComponent(templateType) {
  switch (templateType) {
    case "partners":
      return Partners;

    case "funding":
      return Funding;

    case "glossary":
      return ResourceGlossary;

    case "listing":
      return CMSListing;

    case "homepage":
      return Home;

    case "default":
    default:
      return CMSDefault;
  }
}

// Each content route will now get the route-specific content props from the redux store
const CMSRoute = ({ content, contentKey, isLoading, hasError, ...props }) => {
  const isHome = contentKey === "home";
  const contentData = content[contentKey];

  // The homepage can render its static content immediately while CMS data loads.
  if (!contentData && isHome) {
    const homeFallback = {
      template: "homepage",
      title: "Gulf TREE",
      content: "",
    };

    return (
      <Route
        {...props}
        render={() => <Home contentData={homeFallback} {...props} />}
      />
    );
  }

  // Other CMS routes wait for their specific CMS data.
  if (!contentData) {
    if (hasError && !isLoading) {
      return (
        <section className="center-vertical-wrapper">
          <h3>Unable to load page content.</h3>
        </section>
      );
    }

    return (
      <section className="center-vertical-wrapper">
        <LoadingIcon />
      </section>
    );
  }

  // Render the CMS component corresponding to the requested page.
  const Component = getComponent(contentData.template);

  return (
    <Route
      {...props}
      render={() => <Component contentData={contentData} {...props} />}
    />
  );
};

const mapStateToProps = (state) => ({
  content: state.content.data,
  isLoading: state.content.isLoading,
  hasError: state.content.hasError,
});

CMSRoute.propTypes = {
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
  content: PropTypes.object,
  contentKey: PropTypes.string.isRequired,
  bgClassName: PropTypes.string,
};

export default connect(mapStateToProps)(CMSRoute);
